import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export const SearchOptions = {
    Member: 'Member',
    Prescriber: 'Prescriber',
    IntakeCase: 'Intake Case',
    Fax: 'Fax #',
} as const;
export type SearchOption = (typeof SearchOptions)[keyof typeof SearchOptions];

export interface ArchivedIntakeSourceSliceState {
    searchParams?: {
        searchOption?: SearchOption;
        memberId?: string;
        memberFirstName?: string;
        memberLastName?: string;
        prescriberNpi?: string;
        intakeCaseId?: string;
        faxNumber?: string;
    };
}

const initialState: ArchivedIntakeSourceSliceState = {};

export const archivedIntakeSourceSlice = createSlice({
    name: 'archivedIntakeSource',
    initialState,
    reducers: {
        setArchivedIntakeSourceSearch(
            state,
            action: PayloadAction<{
                searchParams: Required<ArchivedIntakeSourceSliceState>['searchParams'];
            }>,
        ) {
            const { searchParams } = action.payload;
            return { ...state, searchParams };
        },
        clearArchivedIntakeSourceSearch(state) {
            return { ...state, searchParams: undefined };
        },
    },
});

export const { setArchivedIntakeSourceSearch, clearArchivedIntakeSourceSearch } =
    archivedIntakeSourceSlice.actions;
